import script from "./BlogCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogCard.vue?vue&type=script&setup=true&lang=js"

export default script